export interface Tq4AntifoulingM {
  underWateHullCleaningDateOne: Date | string | null;
  underWaterHullCleaningPortNameOne: string;
  underWateHullCleaningAreasCleanedOne: string;
  underWaterHullCleaningHullInspectedOne: string;
  underWaterHullCleaningHullCleanedOne: string;
  underWateHullCleaningPropellerPolishedOne: string;
  underWaterHullCleaningNzMpiStandardCleaningOne: string;
  underWateHullCleaningDateTwo: Date | string | null;
  underWaterHullCleaningPortNameTwo: string;
  underWateHullCleaningAreasCleanedTwo: string;
  underWaterHullCleaningHullInspectedTwo: string;
  underWaterHullCleaningHullCleanedTwo: string;
  underWateHullCleaningPropellerPolishedTwo: string;
  underWaterHullCleaningNzMpiStandardCleaningTwo: string;
  dateOfIssuanceAntifoulingCertificate: Date | string | null;
  dateOfPaintApplication: Date | string | null;
  typeOfAntiFoulingSystem: { value: string; label: string } | null;
  antiFoulingSystemManufacturer: { value: string; label: string } | null;
  nameOfAntiFoulingsystemOne: { value: string; label: string } | null;
  nameOfAntiFoulingsystemOneOthers: string;
  nameOfAntiFoulingsystemTwo: { value: string; label: string } | null;
  nameOfAntiFoulingsystemTwoOthers: string;
  nameOfAntiFoulingsystemThree: { value: string; label: string } | null;
  nameOfAntiFoulingsystemThreeOthers: string;
  lastDryDockingDate: Date | string | null;
  hasUnderwaterHullInspectionAfterLastDrydock: string;
  lastDryDockingLocation: string;
  antiFoulingBootTopCoating: string;
  antiFoulingVerticalBottomCoating: string;
  antiFoulingFlatBottomCoating: string;
  propellerPaintedCoated: string;
  serviceLifeAfsMonths: string;
  frequencyOfScheduledInspections: string;
  nextScheduledDryDocking: Date | string | null;
  isThereAProcedurePlacedByOwners: string;
}

export type Tq4AntifoulingCoatingField =
  | "antiFoulingBootTopCoating"
  | "antiFoulingVerticalBottomCoating"
  | "antiFoulingFlatBottomCoating";

export function mapSqlToTq4AntifoulingForm(_antifouling: any): Tq4AntifoulingM {
  return {
    underWateHullCleaningDateOne: _antifouling?.UNDER_WATER_HULL_CLEANING_DATE_ONE,
    underWaterHullCleaningPortNameOne: _antifouling?.UNDER_WATER_HULL_CLEANING_PORT_NAME_ONE ?? "",
    underWateHullCleaningAreasCleanedOne: _antifouling?.UNDER_WATER_HULL_CLEANING_AREAS_CLEANED_ONE,
    underWaterHullCleaningHullInspectedOne: _antifouling?.UNDER_WATER_HULL_CLEANING_HULL_INSPECTED_ONE ?? "",
    underWaterHullCleaningHullCleanedOne: _antifouling?.UNDER_WATER_HULL_CLEANING_HULL_CLEANED_ONE ?? "",
    underWateHullCleaningPropellerPolishedOne: _antifouling?.UNDER_WATER_HULL_CLEANING_PROPELLER_POLISHED_ONE,
    underWaterHullCleaningNzMpiStandardCleaningOne:
      _antifouling?.UNDER_WATER_HULL_CLEANING_NZ_MPI_STANDARD_CLEANING_ONE ?? "",
    underWateHullCleaningDateTwo: _antifouling?.UNDER_WATER_HULL_CLEANING_DATE_TWO,
    underWaterHullCleaningPortNameTwo: _antifouling?.UNDER_WATER_HULL_CLEANING_PORT_NAME_TWO ?? "",
    underWateHullCleaningAreasCleanedTwo: _antifouling?.UNDER_WATER_HULL_CLEANING_AREAS_CLEANED_TWO,
    underWaterHullCleaningHullInspectedTwo: _antifouling?.UNDER_WATER_HULL_CLEANING_HULL_INSPECTED_TWO ?? "",
    underWaterHullCleaningHullCleanedTwo: _antifouling?.UNDER_WATER_HULL_CLEANING_HULL_CLEANED_TWO ?? "",
    underWateHullCleaningPropellerPolishedTwo: _antifouling?.UNDER_WATER_HULL_CLEANING_PROPELLER_POLISHED_TWO,
    underWaterHullCleaningNzMpiStandardCleaningTwo:
      _antifouling?.UNDER_WATER_HULL_CLEANING_NZ_MPI_STANDARD_CLEANING_TWO ?? "",
    dateOfIssuanceAntifoulingCertificate: _antifouling?.DATE_OF_ISSUANCE_ANTI_FOULING_CERTIFICATE,
    dateOfPaintApplication: _antifouling?.DATE_OF_PAINT_APPLICATION,
    typeOfAntiFoulingSystem: {
      value: _antifouling?.TYPE_OF_ANTI_FOULING_SYSTEM_LABEL,
      label: _antifouling?.TYPE_OF_ANTI_FOULING_SYSTEM_LABEL,
    },
    antiFoulingSystemManufacturer: {
      value: _antifouling?.ANTI_FOULING_SYSTEM_MANUFACTURER_VALUE,
      label: _antifouling?.ANTI_FOULING_SYSTEM_MANUFACTURER_LABEL,
    },
    nameOfAntiFoulingsystemOne: {
      value: _antifouling?.NAME_OF_ANTI_FOULING_SYSTEM_ONE_VALUE,
      label: _antifouling?.NAME_OF_ANTI_FOULING_SYSTEM_ONE_LABEL,
    },
    nameOfAntiFoulingsystemOneOthers: _antifouling?.NAME_OF_ANTI_FOULING_SYSTEM_ONE_OTHERS,
    nameOfAntiFoulingsystemTwo: {
      value: _antifouling?.NAME_OF_ANTI_FOULING_SYSTEM_TWO_VALUE,
      label: _antifouling?.NAME_OF_ANTI_FOULING_SYSTEM_TWO_LABEL,
    },
    nameOfAntiFoulingsystemTwoOthers: _antifouling?.NAME_OF_ANTI_FOULING_SYSTEM_TWO_OTHERS,
    nameOfAntiFoulingsystemThree: {
      value: _antifouling?.NAME_OF_ANTI_FOULING_SYSTEM_THREE_VALUE,
      label: _antifouling?.NAME_OF_ANTI_FOULING_SYSTEM_THREE_LABEL,
    },
    nameOfAntiFoulingsystemThreeOthers: _antifouling?.NAME_OF_ANTI_FOULING_SYSTEM_THREE_OTHERS,
    lastDryDockingDate: _antifouling?.LAST_DRY_DOCKING_DATE,
    hasUnderwaterHullInspectionAfterLastDrydock: _antifouling?.HAS_UNDERWATER_HULL_INSPECTION_AFTER_LAST_DRY_DOCK,
    lastDryDockingLocation: _antifouling?.LAST_DRY_DOCKING_LOCATION,
    antiFoulingBootTopCoating: _antifouling?.ANTI_FOULING_BOOT_TOP_COATING,
    antiFoulingVerticalBottomCoating: _antifouling?.ANTI_FOULING_VERTICAL_BOTTOM_COATING,
    antiFoulingFlatBottomCoating: _antifouling?.ANTI_FOULING_FLAT_BOTTOM_COATING,
    propellerPaintedCoated: _antifouling?.PROPELLER_PAINTED_COATED,
    serviceLifeAfsMonths: _antifouling?.SERVICE_LIFE_AFS_MONTHS,
    frequencyOfScheduledInspections: _antifouling?.FREQUENCY_OF_SCHEDULED_INSPECTIONS,
    nextScheduledDryDocking: _antifouling?.NEXT_SCHEDULED_DRY_DOCKING,
    isThereAProcedurePlacedByOwners: _antifouling?.IS_THERE_A_PROCEDURE_PLACED_BY_OWNERS,
  };
}
